//TODO: move ths into common/ui project
export const openExternalLink = (url: string) => {
  window.location.href = url;
};
